// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyC_kWFm0lFwtRex6wzxr1nrP06AIAsswIg',
    authDomain: 'stok-5d006.firebaseapp.com',
    projectId: 'stok-5d006',
    storageBucket: 'stok-5d006.appspot.com',
    messagingSenderId: '2772971608',
    appId: '1:2772971608:web:4f9f0825b2ebc62469da2d'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
